var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("path", {
      attrs: {
        d: "M28.302 23.264V11.219a.809.809 0 00-.802-.816.808.808 0 00-.801.816v12.045c-2.403-.768-5.151-4.726-5.151-8.777 0-3.155 3.7-8.413 5.952-11.21 2.252 2.797 5.953 8.055 5.953 11.21 0 4.05-2.748 8.01-5.15 8.777M28.45.414c-.484-.552-1.418-.552-1.901 0-.773.881-7.55 8.768-7.55 14.073C19 20.19 23.29 26 27.5 26S36 20.19 36 14.487C36 9.182 29.224 1.295 28.451.413",
      },
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M14.913 32.352c-2.163-.348-4.303-1.405-5.725-2.826-2.172-2.171-3.2-8.384-3.548-11.887 3.503.346 9.716 1.372 11.892 3.548 2.892 2.89 3.65 7.79 2.3 9.89l-8.348-8.344a.795.795 0 00-1.125 1.122l8.23 8.227c-.932.399-2.224.505-3.676.27m4.405-12.951c-3.654-3.652-13.835-4.333-14.984-4.399a1.259 1.259 0 00-1.332 1.332c.066 1.15.746 11.324 4.4 14.978 1.81 1.808 4.401 3.095 7.11 3.533.646.104 1.273.155 1.873.155 2.046 0 3.777-.596 4.902-1.72 2.951-2.95 1.957-9.954-1.97-13.88",
      },
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M14.497 48.453c-3.152 0-8.407-3.701-11.202-5.954 2.795-2.252 8.05-5.952 11.202-5.952 4.198 0 8.304 2.959 8.848 5.419H11.23a.808.808 0 00-.815.802c0 .443.364.801.815.801h11.94c-.962 2.336-4.778 4.884-8.674 4.884m0-14.453C9.196 34 1.315 40.776.434 41.549a1.266 1.266 0 00-.434.95c0 .363.158.709.434.951.88.773 8.762 7.55 14.063 7.55C20.195 51 26 46.71 26 42.5c0-4.212-5.805-8.5-11.503-8.5M41.503 48.453c-3.897 0-7.712-2.548-8.676-4.884H44.77a.808.808 0 00.816-.801.808.808 0 00-.816-.802H32.655c.544-2.46 4.65-5.419 8.848-5.419 3.153 0 8.408 3.7 11.203 5.952-2.795 2.253-8.05 5.954-11.203 5.954m14.064-6.904C54.687 40.776 46.805 34 41.503 34 35.805 34 30 38.288 30 42.5c0 4.21 5.805 8.5 11.503 8.5 5.302 0 13.183-6.777 14.064-7.55.276-.242.433-.588.433-.95 0-.363-.157-.71-.433-.951",
      },
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M44.81 29.532c-2.684 2.686-7.1 3.528-9.399 2.555l8.229-8.227a.795.795 0 00-1.123-1.124l-8.348 8.346c-1.351-2.098-.594-7 2.3-9.892 2.17-2.173 8.387-3.202 11.891-3.55-.348 3.505-1.376 9.72-3.55 11.892m5.821-14.162a1.25 1.25 0 00-.966-.367c-1.149.066-11.33.747-14.983 4.4-3.926 3.926-4.92 10.933-1.97 13.885C33.875 34.449 35.667 35 37.653 35c3.053 0 6.564-1.303 8.944-3.682 3.653-3.654 4.335-13.834 4.4-14.982.022-.36-.112-.711-.366-.966M27.5 56c-.828 0-1.5-.565-1.5-1.262V29.26c0-.696.672-1.261 1.5-1.261s1.5.565 1.5 1.261v25.477c0 .697-.672 1.262-1.5 1.262",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }